module.exports = __webpack_public_path__ + "static/AllSpeakers-f7812d16911fc876fbcfe19f458492d0.jpg";